var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "show_enc"
  }, [_c('Input', {
    attrs: {
      "value": _vm.showValue,
      "disabled": _vm.disabled || !_vm.show,
      "suffix": "ios-eye-off-outline",
      "element-id": _vm.documentId
    },
    on: {
      "input": _vm.input
    }
  }, [_c('Icon', {
    attrs: {
      "slot": "suffix",
      "type": _vm.type
    },
    on: {
      "click": _vm.showText
    },
    slot: "suffix"
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };